import * as fs from "fs";
import * as ko from "knockout";
import Navigo = require("navigo");
import { RNSAPI } from "../../api";
import { Utils } from "../../utils";
import { LawFirmRegistration } from "../../types/LawFirmRegistration";
export class RegisterViewModel {
    getRecaptchaCode = function () {
        return $('.g-recaptcha-response').val();
    };
    router = new Navigo(null, true);
    step = ko.observable('');
    currentStep = ko.observable(1);
    kdNumber = ko.observable('');
    usNummer = ko.observable('');
    regEmail = ko.observable('');
    submitedRegister = ko.observable(false);
    registerErrorFail = ko.observable(false);
    agreed = ko.observable(false);
    // FriendlyCaptcha
    friendlySitekey = ko.observable('FCMHM4IUHBLHBRUV');
    friendlyCaptchaError = ko.observable(false);
    friendlyCaptchaErrorText = ko.observable('');
    anredeTitle = ko.observable('');
    kenzil = ko.observable({
        kanzleiname: ko.observable(''),
        kanzleistrasse: ko.observable(''),
        kanzleiaddition: ko.observable(''),
        kanzleiplz: ko.observable(''),
        kanzleiort: ko.observable(''),
        rain_telefon: ko.observable('+49'),
        kanzleiurl: ko.observable('www.'),
        rain_kinstitut: ko.observable(''),
        rain_kontoinhaber: ko.observable(''),
        rain_bic: ko.observable(''),
        rain_iban: ko.observable(''),
        rain_produkt: ko.observable('Testversion'),
        soldanid: ko.observable('')
    });
    rainUser = ko.observable({
        rain_anrede: ko.observable(''),
        rain_vorname: ko.observable(''),
        rain_title: ko.observable(''),
        rain_name: ko.observable(''),
        rain_email: ko.observable(''),
        rain_username: ko.observable(''),
        rain_password: ko.observable(''),
        rain_password_c: ko.observable(''),
        rain_telefon: ko.observable(''),
        rain_mobile: ko.observable('+49')
    });
    recaptchResponse = ko.observable('');
    recaptchaLoading: boolean = true;
    hasRecaptchaLoaded: boolean = false;
    hasRecapthaExpired = ko.observable(false);
    defaultLocale: string = 'de';
    validCaptcha = ko.computed({
        owner: this,
        read: () => this.recaptchResponse() && !this.hasRecapthaExpired()
    });
    registerSuccessful = ko.observable(false);
    nextRegisterStep() {
        if (this.currentStep() === 1) {
            if (!this.registerValidation(1))
                return;
            $("#kanzlei_content").hide();
            $("#kanzlei_step div").removeClass("visible");
            $("#person_content").show();
            $("#person_step .register-step-status").addClass("active");
            $("#person_step div").addClass("visible");
            $("#backtologin").hide();
            $("#previousStepButton").show();
            this.currentStep(2);
        }
        else if (this.currentStep() === 2) {
            if (!this.registerValidation(2))
                return;
            $("#person_content").hide();
            $("#person_step div").removeClass("visible");
            $("#_content").show();
            $("#pay_step .register-step-status").addClass("active");
            $("#produkt_content2").show();
            $("#produkt_content2 div").addClass("visible");
            this.changeTarif();
            this.currentStep(3);
        }
        else if (this.currentStep() === 3) {
            if (!this.registerValidation(3))
                return;
            this.anredeTitle(ko.toJS(this.rainUser().rain_anrede));
            if (ko.toJS(this.rainUser().rain_title) !== "Bitte wählen Sie") {
                let x = ko.toJS(this.rainUser().rain_anrede) + " " + ko.toJS(this.rainUser().rain_title);
                this.anredeTitle(x);
            }
            $("#payment_content2").hide();
            $("#payment_content2 div").removeClass("visible");
            $("#produkt_content2").hide();
            $("#produkt_content2 div").removeClass("visible");
            $("#summery_content").show();
            $("#summery_step .register-step-status").addClass("active");
            $("#summery_step div").addClass("visible");
            $("#nextStepButton").hide();
            $("#registersubmit").show();
            this.currentStep(4);
            // Initialize FriendlyCaptcha when summary step is shown
            this.initFriendlyCaptcha();
        }
    }
    previousRegisterStep() {
        $("#nextStepButton").show();
        if (this.currentStep() === 4) {
            $("#registersubmit").hide();
            $("#summery_content").hide();
            $("#summery_step div").removeClass("visible");
            $("#summery_step .register-step-status").removeClass("active");
            $("#produkt_content2").show();
            $("#produkt_content2 div").addClass("visible");
            this.changeTarif();
            this.currentStep(3);
        }
        else if (this.currentStep() === 3) {
            $("#produkt_content2").hide();
            $("#produkt_content2 div").removeClass("visible");
            $("#payment_content2").hide();
            $("#payment_content2 div").removeClass("visible");
            $("#_content").show();
            $("#pay_step .register-step-status").removeClass("active");
            $("#person_content").show();
            $("#person_step div").addClass("visible");
            this.currentStep(2);
        }
        else if (this.currentStep() === 2) {
            $("#person_content").hide();
            $("#person_step div").removeClass("visible");
            $("#kanzlei_content").show();
            $("#person_step .register-step-status").removeClass("active");
            $("#kanzlei_step div").addClass("visible");
            $("#previousStepButton").hide();
            $("#backtologin").show();
            this.currentStep(1);
        }
    }
    checkPassword() {
        $("#pc_validation_message").hide();
        if (!(/^(?=.{12,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*\W).*$/.test(ko.toJS(this.rainUser().rain_password).toString()))) {
            $("#pc_validation_message").show();
            $('#pc_message').html('Bitte mindestens 12 Zeichen und eine Kombination aus Kleinbuchstaben, Großbuchstaben, Ziffern und Sonderzeichen verwenden.');
        }
    }
    checkPasswordMatch() {
        var passwort = $("#rain_password").val();
        var passwort_wdh = $("#rain_password_c").val();
        $("#pc_validation_message").hide();
        if (passwort !== passwort_wdh) {
            $("#pc_validation_message").show();
            $("#pc_message").html("Die Passwörter stimmen nicht überein.");
        }
    }
    registerValidation(step) {
        var passwort = $("#rain_password").val();
        var passwort_wdh = $("#rain_password_c").val();
        var produkt = $("#produkt").val();
        var kreditinstitut = $("#kreditinstitut").val();
        var kontoinhaber = $("#kontoinhaber").val();
        var bic = $("#bic").val();
        var iban = $("#iban").val();
        if (step == 1) {
            if (!Utils.checkMultipleErrors(["kanzleiname", "kanzleistrasse", "kanzleiplz", "kanzleiort", "rain_telefon"], this.kenzil(), "", [Utils.checkString, Utils.checkPhone])) {
                $("#kc_validation_message").show();
                return false;
            }
            else {
                $("#kc_validation_message").hide();
                return true;
            }
        }
        else if (step == 2) {
            if (!Utils.checkMultipleErrors(["rain_anrede", "rain_vorname", "rain_name", "rain_email", "rain_username", "rain_password", "rain_password_c", "rain_mobile"], this.rainUser(), "", [Utils.checkString, Utils.checkPhone])) {
                $("#pc_validation_message").show();
                $("#pc_message").html("Es wurden nicht alle erforderlichen Eingabefelder ausgefüllt.");
                return false;
            }
            else {
                // Validate email format for required email field
                if (!Utils.checkErrors(["rain_email"], this.rainUser(), "", [Utils.checkEmail])) {
                    $("#pc_validation_message").show();
                    $("#pc_message").html("Ungültige E-Mail Adresse.");
                    return false;
                }
                if (ko.toJS(this.rainUser().rain_password) === ko.toJS(this.rainUser().rain_password_c) && /^(?=.{12,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*\W).*$/.test(ko.toJS(this.rainUser().rain_password).toString())) {
                    $("#pc_validation_message").hide();
                    return true;
                }
                else {
                    if (passwort !== passwort_wdh) {
                        $("#pc_message").html("Die Passwörter stimmen nicht überein.");
                    }
                    else {
                        $('#pc_message').html('Bitte mindestens 12 Zeichen und eine Kombination aus Kleinbuchstaben, Großbuchstaben, Ziffern und Sonderzeichen verwenden.');
                    }
                    $("#pc_validation_message").show();
                    return false;
                }
            }
        }
        else if (step == 3) {
            return true;
        }
    }
    gotoLogin() {
        this.router.navigate('/login');
    }
    gotoPerson() {
        this.currentStep(2);
        $("#summery_content").hide();
        $("#summery_step div").removeClass("visible");
        $("#summery_step .register-step-status").removeClass("active");
        $("#person_content").show();
        $("#person_step div").addClass("visible");
        $("#previousStepButton").show();
        $("#nextStepButton").show();
        $("#registersubmit").hide();
    }
    gotoKenzil() {
        this.currentStep(1);
        $("#person_content").hide();
        $("#person_step div").removeClass("visible");
        $("#kanzlei_content").show();
        $("#person_step .register-step-status").removeClass("active");
        $("#kanzlei_step div").addClass("visible");
        $("#summery_content").hide();
        $("#summery_step div").removeClass("visible");
        $("#summery_step .register-step-status").removeClass("active");
        $("#previousStepButton").hide();
        $("#backtologin").show();
        $("#registersubmit").hide();
        $("#nextStepButton").show();
    }
    checkKanzleiurl(value): string {
        return ['www.', '', null, undefined].indexOf(value) === -1 ? value : '';
    }
    async registerCourt() {
        // Iterate through all potential captcha inputs and pick the first non-empty value
        const captchas = document.getElementsByName('frc-captcha-response');
        for (let i = 0; i < captchas.length; i++) {
            const el = captchas[i] as HTMLInputElement;
            if (el && el.value && el.value.trim() !== '') {
                this.recaptchResponse(el.value.trim());
                this.hasRecapthaExpired(false);
                this.friendlyCaptchaError(false);
                this.friendlyCaptchaErrorText('');
                break; // use the first solved captcha
            }
        }
        if (!this.submitedRegister()) {
            const captchaEmpty = !this.recaptchResponse() || this.recaptchResponse().trim() === '';
            if (!this.agreed() || captchaEmpty || this.hasRecapthaExpired()) {
                $("#final_validation_message").show();
                if (captchaEmpty || this.hasRecapthaExpired()) {
                    this.friendlyCaptchaError(true);
                    this.friendlyCaptchaErrorText('Bitte lösen Sie das Captcha.');
                }
                return;
            }
            this.submitedRegister(true);
            const data: LawFirmRegistration = {
                LawFirmName: this.kenzil().kanzleiname(),
                Website: this.checkKanzleiurl(this.kenzil().kanzleiurl()),
                SoldanId: this.kenzil().soldanid() === "" ? "0" : this.kenzil().soldanid(),
                IsSoldanPrintVersion: false,
                Address: this.kenzil().kanzleistrasse(),
                AdditionalAddress: this.kenzil().kanzleiaddition(),
                PostCode: this.kenzil().kanzleiplz(),
                Place: this.kenzil().kanzleiort(),
                Phone: this.kenzil().rain_telefon(),
                FormOfAddress: this.rainUser().rain_anrede(),
                Title: this.rainUser().rain_title(),
                Lastname: this.rainUser().rain_name(),
                Firstname: this.rainUser().rain_vorname(),
                Mobile: this.rainUser().rain_mobile(),
                Mail: this.rainUser().rain_email(),
                Username: this.rainUser().rain_username(),
                Password: this.rainUser().rain_password(),
                Product: this.kenzil().rain_produkt(),
                AccountOwner: this.kenzil().rain_kontoinhaber(),
                CreditInstitution: this.kenzil().rain_kinstitut(),
                IBAN: this.kenzil().rain_iban(),
                BIC: this.kenzil().rain_bic(),
                CaptchaResponse: this.recaptchResponse()
            };
            await RNSAPI.registerLawFirm(data).then(data => {
                this.registerSuccessful(true);
                this.kdNumber(data["LawFirmId"]);
                this.usNummer(data["Username"]);
                this.regEmail(data["Mail"]);
                localStorage.setItem('LawFirmInfo', JSON.stringify({
                    ShorthandSymbol: this.usNummer(),
                    LawFirmId: this.kdNumber()
                }));
            }).catch(error => {
                this.submitedRegister(false);
                $("#summery_content").show();
                this.registerErrorFail(true);
            });
        }
    }
    async cityFilter() {
        let result = await RNSAPI.getPostcode(this.kenzil().kanzleiplz());
        if (result.Type == "GetPostcodeResult" && result.Payload.Cities.length > 0) {
            this.kenzil().kanzleiort(result.Payload.Cities[0]);
        }
    }
    async generateShorthand() {
        if (ko.toJS(this.rainUser().rain_vorname) !== '' && ko.toJS(this.rainUser().rain_name) !== '') {
            this.rainUser().rain_username(ko.toJS(this.rainUser().rain_vorname)[0] + ko.toJS(this.rainUser().rain_name)[0]);
        }
    }
    agreement() {
        this.agreed(!this.agreed());
    }
    microtime(getAsFloat) {
        var s, now = (Date.now ? Date.now() : new Date().getTime()) / 1000;
        if (getAsFloat) {
            return now;
        }
        s = now | 0;
        return (Math.round((now - s) * 1000) / 1000) + ' ' + s;
    }
    verifyCallback(response) {
        this.recaptchResponse(response);
        this.hasRecapthaExpired(false);
    }
    recaptchaExpiredCallback() {
        this.hasRecapthaExpired(true);
    }
    onloadCallback() {
        // Legacy reCAPTCHA (kept for backward compatibility but not used)
        this.recaptchaLoading = false;
        this.hasRecaptchaLoaded = true;
    }
    displayRecaptcha() {
        // Legacy reCAPTCHA loader (no-op)
    }

    // FriendlyCaptcha SDK + legacy widget integration
    private friendlyWidgetLoaded: boolean = false;
    private friendlySdkLoaded: boolean = false;
    private friendlyInitialized: boolean = false;
    private expiryTimer: any = null;

    private clearExpiryTimer() {
        if (this.expiryTimer) {
            clearTimeout(this.expiryTimer);
            this.expiryTimer = null;
        }
    }

    private scheduleFriendlyExpiry(details?: any) {
        this.clearExpiryTimer();
        const ts = details?.timestamp;
        const ttl = details?.expires_in;
        if (typeof ts === 'number' && typeof ttl === 'number') {
            const now = Date.now();
            const dueAt = ts + ttl;
            const delay = Math.max(0, dueAt - now);
            this.expiryTimer = setTimeout(() => {
                this.hasRecapthaExpired(true);
                this.recaptchResponse('');
                const hidden = document.getElementById('frc-solution') as HTMLInputElement;
                if (hidden) hidden.value = '';
            }, delay);
        }
    }

    private extractToken(payload: any): string {
        if (!payload) return '';
        if (typeof payload === 'string') return payload;
        if (payload.data && payload.data.redeem_token) return payload.data.redeem_token;
        if (payload.redeem_token) return payload.redeem_token;
        if (payload.response) return payload.response;
        if (payload.solution) return payload.solution;
        if (payload.value) return payload.value;
        return '';
    }

    private loadFriendlySdkScript(): Promise<void> {
        return new Promise((resolve, reject) => {
            if (this.friendlySdkLoaded) return resolve();
            const existing = document.querySelector("script[data-friendly-sdk]") as HTMLScriptElement;
            if (existing) { this.friendlySdkLoaded = true; return resolve(); }
            const sources = [
                (window as any).FRIENDLY_CAPTCHA_SDK_URL,
                'https://cdn.jsdelivr.net/npm/@friendlycaptcha/sdk@latest/site.min.js',
                'https://unpkg.com/@friendlycaptcha/sdk@latest/dist/site.min.js'
            ].filter(Boolean) as string[];
            let i = 0;
            const tryNext = () => {
                if (i >= sources.length) return reject(new Error('FriendlyCaptcha SDK failed to load'));
                const src = sources[i++];
                const s = document.createElement('script');
                s.src = src;
                s.async = true;
                s.defer = true;
                s.setAttribute('data-friendly-sdk', 'true');
                s.onload = () => { this.friendlySdkLoaded = true; resolve(); };
                s.onerror = () => { tryNext(); };
                document.head.appendChild(s);
            };
            tryNext();
        });
    }

    private loadFriendlyWidgetScript(): Promise<void> {
        return new Promise((resolve, reject) => {
            if (this.friendlyWidgetLoaded) return resolve();
            const existing = document.querySelector("script[data-friendly-widget]") as HTMLScriptElement;
            if (existing) { this.friendlyWidgetLoaded = true; return resolve(); }
            const origin = window.location.origin;
            const v2 = `https://global.frcapi.com/api/v2/captcha/widget?origin=${encodeURIComponent(origin)}&lang=de&sitekey=${encodeURIComponent(this.friendlySitekey())}&ts=${Date.now()}`;
            const sources = [
                (window as any).FRIENDLY_CAPTCHA_WIDGET_URL,
                v2
            ].filter(Boolean) as string[];
            let i = 0;
            const tryNext = () => {
                if (i >= sources.length) return reject(new Error('FriendlyCaptcha widget failed to load'));
                const src = sources[i++];
                const s = document.createElement('script');
                s.src = src;
                s.async = true;
                s.defer = true;
                s.setAttribute('data-friendly-widget', 'true');
                s.onload = () => { this.friendlyWidgetLoaded = true; resolve(); };
                s.onerror = () => { tryNext(); };
                document.head.appendChild(s);
            };
            tryNext();
        });
    }

    private bindFriendlyCaptchaEvents(container: HTMLElement) {
        const onSolution = (solution: string, details?: any) => {
            this.recaptchResponse(solution);
            const hidden = document.getElementById('frc-solution') as HTMLInputElement;
            if (hidden) hidden.value = solution;
            this.friendlyCaptchaError(false);
            this.friendlyCaptchaErrorText('');
            this.hasRecapthaExpired(false);
            this.scheduleFriendlyExpiry(details);
        };
        // Multiple event variants
        container.addEventListener('frc:response', (e: any) => {
            const token = this.extractToken(e?.detail);
            onSolution(token, e?.detail?.details);
        });
        container.addEventListener('frc:success', (e: any) => {
            const token = this.extractToken(e?.detail);
            onSolution(token, e?.detail?.details);
        });
        container.addEventListener('frc:reset', () => {
            this.clearExpiryTimer();
            this.recaptchResponse('');
            const hidden = document.getElementById('frc-solution') as HTMLInputElement;
            if (hidden) hidden.value = '';
            this.hasRecapthaExpired(true);
        });
        container.addEventListener('frc:expired', () => {
            this.clearExpiryTimer();
            this.recaptchResponse('');
            const hidden = document.getElementById('frc-solution') as HTMLInputElement;
            if (hidden) hidden.value = '';
            this.hasRecapthaExpired(true);
        });
        container.addEventListener('frc:error', () => {
            // Do not immediately show a blocking error; some builds emit transient errors before rendering.
            // We will only show an error later if no widget renders at all (handled in loader catch).
            const tokenEmpty = !this.recaptchResponse();
            if (!this.friendlyInitialized && tokenEmpty) {
                // Soft clear any previous message to avoid persistent false positive while widget is visible
                this.friendlyCaptchaError(false);
                this.friendlyCaptchaErrorText('');
            }
        });
    }

    initFriendlyCaptcha() {
        const container = document.getElementById('frc-captcha') as HTMLElement;
        if (!container) return;

        // Ensure sitekey attribute is present (also bound in HTML via KO)
        container.setAttribute('data-sitekey', this.friendlySitekey());
        container.setAttribute('data-lang', 'de');
        container.setAttribute('data-start', 'auto');

        this.bindFriendlyCaptchaEvents(container);

        // Observe rendering to clear stale error messages if widget appears later
        try {
            const clearIfRendered = () => {
                const hasChild = container.children && container.children.length > 0;
                const hasIframe = !!container.querySelector('iframe');
                const hasWidget = !!container.querySelector('[class*="frc"]');
                if (hasChild || hasIframe || hasWidget) {
                    this.friendlyCaptchaError(false);
                    this.friendlyCaptchaErrorText('');
                }
            };
            // Initial delayed check in case rendering is synchronous
            setTimeout(clearIfRendered, 300);
            // MutationObserver to respond to late renders
            const mo = new MutationObserver(() => clearIfRendered());
            mo.observe(container, { childList: true, subtree: true, attributes: true });
        } catch { /* no-op */ }

        // Try SDK first
        this.loadFriendlySdkScript().then(() => {
            const fc = (window as any).friendlyChallenge;
            if (fc && typeof fc.renderWidget === 'function') {
                try {
                    fc.renderWidget(container, {
                        sitekey: this.friendlySitekey(),
                        doneCallback: (solution: any) => {
                            const token = this.extractToken(solution);
                            this.recaptchResponse(token);
                            const hidden = document.getElementById('frc-solution') as HTMLInputElement;
                            if (hidden) hidden.value = token;
                            this.hasRecapthaExpired(false);
                        }
                    });
                    this.friendlyInitialized = true;
                    this.friendlyCaptchaError(false);
                    this.friendlyCaptchaErrorText('');
                    return;
                } catch { /* fall through to legacy */ }
            }
            // If SDK loaded but uses auto discovery
            if (fc && typeof fc.autoWidget === 'function') {
                try { 
                    fc.autoWidget(); 
                    this.friendlyInitialized = true; 
                    this.friendlyCaptchaError(false);
                    this.friendlyCaptchaErrorText('');
                    return; 
                } catch { /* noop */ }
            }
            // Fall back to legacy widget script chain
            this.loadFriendlyWidgetScript().then(() => {
                const fcl = (window as any).friendlyChallenge;
                if (fcl && typeof fcl.autoWidget === 'function') {
                    try { 
                        fcl.autoWidget(); 
                        this.friendlyInitialized = true; 
                        this.friendlyCaptchaError(false);
                        this.friendlyCaptchaErrorText('');
                    } catch { /* noop */ }
                }
            }).catch(() => {
                this.friendlyCaptchaError(true);
                this.friendlyCaptchaErrorText('Captcha konnte nicht geladen werden. Bitte deaktivieren Sie ggf. Ihren Werbeblocker.');
            });
        }).catch(() => {
            // SDK failed: try legacy widget
            this.loadFriendlyWidgetScript().then(() => {
                const fc = (window as any).friendlyChallenge;
                if (fc && typeof fc.autoWidget === 'function') {
                    try { fc.autoWidget(); this.friendlyInitialized = true; } catch { /* noop */ }
                }
            }).catch(() => {
                this.friendlyCaptchaError(true);
                this.friendlyCaptchaErrorText('Captcha konnte nicht geladen werden. Bitte deaktivieren Sie ggf. Ihren Werbeblocker.');
            });
        });
    }

    changeTarif() {
        let selectedEl = (<HTMLSelectElement>document.getElementById("produkt")).value;
        if (selectedEl === "Testversion") {
            $("#TestversionInfo").show();
            $("#TestversionInfo div").addClass("visible");
            $("#payment_content2").hide();
            $("#payment_content2 div").removeClass("visible");
        }
        else {
            $("#TestversionInfo").hide();
            $("#TestversionInfo div").removeClass("visible");
            $("#payment_content2").show();
            $("#payment_content2 div").addClass("visible");
        }
    }
    constructor() {
        $(document).ready(function () {
            $("[data-toggle='tooltip']").tooltip();
        });
    }
}
var html = fs.readFileSync(__dirname + '/register.html', 'utf8');
ko.components.register("register-view", {
    viewModel: RegisterViewModel,
    template: html
});
